import styleInject from './node_modules-style-inject-dist-style-inject.es.js';

var css_248z = "/**\n * Do not edit directly\n * Generated on Mon, 15 Sep 2025 16:58:25 GMT\n */\n.order-items-more {\n  height: 48px;\n  width: 48px;\n  border: 1px solid;\n  border-color: var(--swan-sem-color-border-standard);\n  border-radius: var(--swan-sem-border-radius-subtle);\n  align-content: center;\n  text-align: center;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=src-components-AdvanceMessagingComponent-OrderList-OrderCard.styles.scss.js.map
